var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7969 2.01562H21.4219V7.04688H0.578125V2.01562H9.20312",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7969 2.01562H21.4219V7.04688H0.578125V2.01562H9.20312",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20156 9.92188H3.16562C1.72812 9.92188 0.578125 8.77187 0.578125 7.33437V7.04688H5.78906V7.33437C5.78906 8.77187 4.63906 9.92188 3.20156 9.92188Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20156 9.92188H3.16562C1.72812 9.92188 0.578125 8.77187 0.578125 7.33437V7.04688H5.78906V7.33437C5.78906 8.77187 4.63906 9.92188 3.20156 9.92188Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4125 9.92188H8.37656C6.93906 9.92188 5.78906 8.77187 5.78906 7.33437V7.04688H11V7.33437C11 8.77187 9.85 9.92188 8.4125 9.92188Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4125 9.92188H8.37656C6.93906 9.92188 5.78906 8.77187 5.78906 7.33437V7.04688H11V7.33437C11 8.77187 9.85 9.92188 8.4125 9.92188Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6234 9.92188H13.5875C12.15 9.92188 11 8.77187 11 7.33437V7.04688H16.2109V7.33437C16.2109 8.77187 15.0609 9.92188 13.6234 9.92188Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6234 9.92188H13.5875C12.15 9.92188 11 8.77187 11 7.33437V7.04688H16.2109V7.33437C16.2109 8.77187 15.0609 9.92188 13.6234 9.92188Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8344 9.92188H18.7984C17.3609 9.92188 16.2109 8.77187 16.2109 7.33437V7.04688H21.4219V7.33437C21.4219 8.77187 20.2719 9.92188 18.8344 9.92188Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8344 9.92188H18.7984C17.3609 9.92188 16.2109 8.77187 16.2109 7.33437V7.04688H21.4219V7.33437C21.4219 8.77187 20.2719 9.92188 18.8344 9.92188Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.60938C12.1909 5.60938 13.1562 4.48309 13.1562 3.09375C13.1562 1.70441 12.1909 0.578125 11 0.578125C9.80914 0.578125 8.84375 1.70441 8.84375 3.09375C8.84375 4.48309 9.80914 5.60938 11 5.60938Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.60938C12.1909 5.60938 13.1562 4.48309 13.1562 3.09375C13.1562 1.70441 12.1909 0.578125 11 0.578125C9.80914 0.578125 8.84375 1.70441 8.84375 3.09375C8.84375 4.48309 9.80914 5.60938 11 5.60938Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 19.625H3.8125V14.0188C3.8125 12.5453 4.99844 11.3594 6.47187 11.3594H6.54375C8.01719 11.3594 9.20312 12.5453 9.20312 14.0188V19.625Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 19.625H3.8125V14.0188C3.8125 12.5453 4.99844 11.3594 6.47187 11.3594H6.54375C8.01719 11.3594 9.20312 12.5453 9.20312 14.0188V19.625Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40625 15.6719H8.125",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40625 15.6719H8.125",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 13.0125V16.4984",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 13.0125V16.4984",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 0.578125C12.5451 2.59062 9.45449 3.59688 10.9998 5.60938",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 0.578125C12.5451 2.59062 9.45449 3.59688 10.9998 5.60938",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.578125 3.8125H4.89062",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.578125 3.8125H4.89062",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 3.8125H21.4219",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 3.8125H21.4219",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.578125 5.25H9.92188",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.578125 5.25H9.92188",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 5.25H15.6719",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 5.25H15.6719",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 11.7188H12.4375V17.4688H18.1875V11.7188Z",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 11.7188H12.4375V17.4688H18.1875V11.7188Z",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 19.625H21.4219V21.4219H0.578125V19.625H13.875",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 19.625H21.4219V21.4219H0.578125V19.625H13.875",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 19.625H15.3125",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 19.625H15.3125",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 9.20312V19.625",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 9.20312V19.625",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7031 9.20312V19.625",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7031 9.20312V19.625",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 11.7188V17.4688",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 11.7188V17.4688",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 14.5938H18.1875",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 14.5938H18.1875",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60938 3.8125H6.32812",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60938 3.8125H6.32812",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 3.8125H8.84375",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04688 3.8125H8.84375",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3906 5.25H17.1094",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3906 5.25H17.1094",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 5.25H21.4219",
    stroke: "#ffffffbf",
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8281 5.25H21.4219",
    stroke: "white",
    strokeOpacity: 0.65,
    strokeWidth: 0.71875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShops);
export default __webpack_public_path__ + "static/media/shops.b8b733061d7ca11ac5cde6409c654e62.svg";
export { ForwardRef as ReactComponent };